/**
 * "Tu asistente" del armador de Maderinco: cuando entra a guiar (MADERINCO-ASISTENTE-GUIADO-T1).
 *
 * Josse 28-oct (#36553 punto 4): "Guiame seccion por seccion" recorre las secciones del CLIENTE en su orden; el paso
 * lo calcula capitulosDelCliente.pasoPorSecciones. El recorrido por los arboles de Atenea (pasoGuiado) se retiro con
 * esa decision: los arboles siguen en pantalla, dentro de la seccion del cliente que les toca.
 *
 * @module application/presupuestos/asistenteGuiado
 */

/**
 * El copiloto entra al recorrido con estas frases (y con el boton "Guíame"). Obs de Q en 475 (#30450): el mensaje
 * ENTERO tiene que ser la orden; "agrega el siguiente item" o "arma una cubierta de 20 m2" siguen siendo otra cosa.
 */
export function pideGuia(texto) {
  const t = String(texto || '').trim().toLowerCase().replace(/[.!?¡¿]+/g, '').replace(/\s+/g, ' ');
  return /^(gu[ií]a(me)?|gu[ií]ame (secci[oó]n por secci[oó]n|con el presupuesto)|siguiente|sigamos|qu[eé] sigue|empecemos|armemos( el presupuesto)?|ay[uú]dame a armar( el presupuesto)?)$/.test(t);
}
